export default "/_next/static/images/img5-63f350d8da624bed3e87696c071e1dac.png";